export default __webpack_public_path__ + "static/media/gallery_01.471945c7.jpg";